import { Stack } from "@mantine/core";
import { Paths, PathValue } from "@mctypes/global.types";
import * as R from "ramda";
import React, { useEffect } from "react";
import { useDebounce } from "usehooks-ts";
import { VSpace } from "../../../../components";
import { IGeoTeknikkRapport } from "@mcapps/shared/reportSchemas/geoteknikSchema";
import GeoteknikGenrellInfo from "./GeoteknikGenerellInfo";
import GeoteknikMaps from "./GeoteknikMaps";
import GeoteknikSettings from "./GeoteknikSettings";

const GeoteknikOmraadestabilitetsRapport: React.FC<{
  createdAt?: string;
  data: IGeoTeknikkRapport;
  onUpdateEditData: (data: IGeoTeknikkRapport) => void;
  projectId: string;
  userName: string;
}> = ({ createdAt, data, onUpdateEditData, projectId, userName }) => {
  const [editData, setEditData] = React.useState(R.clone(data));
  const debouncedValue = useDebounce<IGeoTeknikkRapport>(editData, 1000);

  useEffect(() => {
    onUpdateEditData(editData);
  }, [editData]);

  React.useEffect(() => {
    setEditData(null);
    setTimeout(() => {
      setEditData(data);
    }, 50);
  }, [createdAt]);

  const setLabText = (text: string) => {
    updateData("laboratorieresultater", text);
  };

  const updateData = <P extends Paths<IGeoTeknikkRapport, 4>>(path: P, value: PathValue<IGeoTeknikkRapport, P>) => {
    setEditData((prevState) => {
      const updatedData = R.assocPath(path.split("."), value, prevState);
      return updatedData;
    });
    onUpdateEditData(R.assocPath(path.split("."), value, editData));
  };

  return (
    <Stack p="md" style={{ maxWidth: 800, margin: "0 auto" }}>
      {editData != null && (
        <>
          <GeoteknikSettings
            veiledningsTekst={editData.innstillinger?.veiledningsTekst}
            eksempelTekst={editData.innstillinger?.eksempelTekst}
            updateVeiledningsTekst={(bool) => updateData("innstillinger.veiledningsTekst", bool)}
            updateEksempelTekst={(bool) => updateData("innstillinger.eksempelTekst", bool)}
          />
          <VSpace />
          <GeoteknikGenrellInfo editData={editData} updateData={updateData} />
        </>
      )}
      <VSpace />
      <GeoteknikMaps
        geoteknikKoordinater={editData?.prosjektInformasjon?.koordinater}
        onUpdateGeoteknikKoordinater={(koordinater) => updateData("prosjektInformasjon.koordinater", koordinater)}
        sirkelDiameter={editData?.prosjektInformasjon?.sirkelDiameter}
        onUpdateSirkelDiameter={updateData}
        zoomLevel={editData?.prosjektInformasjon?.zoomLevel}
        onUpdateZoomLevel={(zoomLevel) => updateData("prosjektInformasjon.zoomLevel", zoomLevel)}
      />
      <div style={{ height: "400px" }} />
    </Stack>
  );
};

export default GeoteknikOmraadestabilitetsRapport;
